import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      user: {
        id: localStorage.getItem("Creative_System_Dash_User_Id"),
        token: localStorage.getItem("Creative_System_Dash_Token"),
        usertype: localStorage.getItem("Creative_System_Dash_User_Type"),
        image: localStorage.getItem("Creative_System_Dash_userImg"),
        phone: localStorage.getItem("Creative_System_Dash_userPhone"),
      },
    };
  },
  mutations,
  actions,
  getters,
};
